
import { useMemo } from 'react';

interface NutritionTargets {
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
  iron: number;
  calcium: number;
  zinc: number;
  magnesium: number;
  omega3: number;
}

interface UserProfile {
  weight?: number;
  targetCalories?: number;
  targetProtein?: number;
  targetCarbs?: number;
  targetFat?: number;
  targetIron?: number;
  targetCalcium?: number;
  targetZinc?: number;
  targetMagnesium?: number;
  targetOmega3?: number;
  gender?: string;
}

export const useOptimizedCalculations = (profile: UserProfile | null) => {
  const nutritionTargets = useMemo((): NutritionTargets => {
    if (!profile) {
      return {
        calories: 2000,
        protein: 75,
        carbs: 250,
        fat: 65,
        iron: 18,
        calcium: 1000,
        zinc: 11,
        magnesium: 400,
        omega3: 1.6
      };
    }

    const weight = profile.weight || 70;
    // ALWAYS use 0.8 g/kg for protein calculation
    const calculatedProtein = Math.round(weight * 0.8);
    
    console.log('🧮 useOptimizedCalculations PROTEIN DEBUG:', {
      weight,
      calculation: `${weight} * 0.8 = ${weight * 0.8}`,
      rounded: calculatedProtein,
      profileTargetProtein: profile.targetProtein
    });

    return {
      calories: Math.round(profile.targetCalories || 2000),
      protein: calculatedProtein, // Always use calculated protein, ignore profile.targetProtein
      carbs: Math.round(profile.targetCarbs || 250),
      fat: Math.round(profile.targetFat || 65),
      iron: Math.round(profile.targetIron || (profile.gender === 'female' ? 18 : 8)),
      calcium: Math.round(profile.targetCalcium || 1000),
      zinc: Math.round(profile.targetZinc || 11),
      magnesium: Math.round(profile.targetMagnesium || 400),
      omega3: Math.round(profile.targetOmega3 || 1.6)
    };
  }, [profile?.weight, profile?.targetCalories, profile?.targetCarbs, profile?.targetFat, profile?.targetIron, profile?.targetCalcium, profile?.targetZinc, profile?.targetMagnesium, profile?.targetOmega3, profile?.gender]);

  return {
    nutritionTargets
  };
};
